/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BackToSignInAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function BackToSignInAction({
  children,
  viewPath = "/App/Auth/ResetPassword/BackToSignInAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 size="normal"
 color={dtColorsNeutral700}
 text="Back to Sign in"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../SignIn'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../SignIn'))}
/>
{children}
</React.Fragment>)
}